import React, { useState } from 'react'
import { Box } from '@mui/material'
import GenericButton from '../../../components/GenericButton'
import { type TruncatedDivision, type Role } from '../../../models/Role'
import GenericAutocomplete from '../../../components/FormElements/FormAutoComplete'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { ButtonType } from '../../../components/GenericButton/styles'
import { shade } from '../../../colors'
import { red } from '@mui/material/colors'
import { ApiAutoComplete } from '../../../components/FormElements/ApiAutoComplete'

interface RoleCardProps {
  loading?: boolean
  deleteLoading?: boolean
  selectRoles?: Role[]
  deleteRole: () => void
  readOnly?: boolean
  selectedRole?: Role
  selectedDivision?: TruncatedDivision
  roleFieldName: string
  divisionFieldName: string
  error?: boolean
  valueFieldForAcademicUnit?: string
}

const RoleCard: React.FC<RoleCardProps> = ({
  loading,
  selectRoles,
  deleteRole,
  readOnly = false,
  selectedRole,
  selectedDivision,
  roleFieldName,
  divisionFieldName,
  deleteLoading = false,
  error = false,
  valueFieldForAcademicUnit
}) => {
  return (
    <Box display="flex" flexDirection="column" gap="24px" padding="24px" my="24px" borderRadius="8px" sx={{ border: error ? `2px solid ${red[600]}` : undefined, background: shade[750] }}>
      <GenericAutocomplete selectedValue={selectedRole?.roleId} readOnly={readOnly} name={roleFieldName} label="Role" options={selectRoles} getOptionLabel={(role) => role?.roleName} getOptionValue={(value) => value?.roleId} loading={loading} required/>
      <ApiAutoComplete
        apiEndpoint='/api/divisions/summary/'
        label="Academic Unit"
        labelField="title"
        valueField={valueFieldForAcademicUnit}
        name={divisionFieldName}
        required
        placeholder='Select Academic Unit'
        selectedItem={selectedDivision}
        readOnly={readOnly}
      />

      <GenericButton onClick={deleteRole} style={{ alignSelf: 'flex-end' }} startIcon={<DeleteOutlineIcon />} label="Delete" buttonType={ButtonType.Destructive} loading={deleteLoading} />
    </Box>
  )
}

export default RoleCard
